import apiClient from "../config/apiClient";

/**
 * Fetches catering orders calendar view for a specific month and year
 * @param {number} year - The year (e.g., 2025)
 * @param {number} month - The month (1-12)
 * @returns {Promise} API response with calendar data
 */
export const getCateringCalendarView = async (year, month) => {
  try {
    const response = await apiClient.get("/agent/list-orders-calendar-view", {
      params: {
        year,
        month,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching catering calendar view:", error);
    throw error;
  }
};

